import {Col, Row} from "antd";
import moment from "moment";
import {t} from "i18next";
import ApiService from "../../../core/service/api-service";
import {info} from "./info";
import {CountBarChart, DailyBarChart, dailySummary, modalitySlot, PanelSpin, percent, Tile, usePanelData} from "./PanelParts";

const fetchMine = (filter) => ApiService.Dashboard.MyWrites(filter)

/**
 * Raportör panosu: yazılan rapor (İstatistikler sekmesiyle aynı tanım — bu kullanıcının yazdığı
 * onaylı raporlar). fetcher verilmezse kullanıcının kendi verisi; yönetici Panom'da seçtiği kullanıcınınkini verir.
 */
export default function ReporterPanel({filter, fetcher = fetchMine}) {
    const {data, loading} = usePanelData(fetcher, filter)
    const summary = dailySummary(data?.daily)

    return (
        <PanelSpin loading={loading}>
            <Row gutter={[12, 12]}>
                <Col xs={12} md={8}>
                    <Tile title={t('Written reports')} value={data?.total} info={info('writtenReports')}/>
                </Col>
                <Col xs={12} md={8}>
                    <Tile title={t('Emergency')} value={data?.emergencyTotal} hint={percent(data?.emergencyTotal, data?.total)} info={info('emergency')}/>
                </Col>
                <Col xs={12} md={8}>
                    <Tile
                        title={t('Daily average')}
                        info={info('dailyAverage')}
                        value={summary.average}
                        hint={summary.busiest
                            ? `${t('Busiest day')}: ${moment(summary.busiest.day).format('DD.MM.YYYY')} (${summary.busiest.count})`
                            : null}
                    />
                </Col>

                <Col xs={24}>
                    <DailyBarChart title={t('Written reports by day')} info={info('writtenByDay')} daily={data?.daily}/>
                </Col>

                <Col xs={24} md={12}>
                    <CountBarChart title={t('By modality')} info={info('byModality')} items={data?.modalities} slotOf={modalitySlot}/>
                </Col>
            </Row>
        </PanelSpin>
    )
}
